import { render, staticRenderFns } from "./CredentialProcessRequest.vue?vue&type=template&id=16745a7a&scoped=true&"
import script from "./CredentialProcessRequest.vue?vue&type=script&lang=js&"
export * from "./CredentialProcessRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16745a7a",
  null
  
)

export default component.exports